<template>
  <div class="px-4 py-6 bg-grey lighten-4 d-flex align-center">
    <v-autocomplete
        v-model="selected"
        :items="centers"
        item-text="desc"
        item-value="_id"
        label="Centri sportivi gestiti"
        return-object
        :loading="loading"
        hide-no-data
        @change="handleSwitch"
        dense
        hide-details
    />
  </div>

</template>

<script>
import {mapActions, mapMutations} from 'vuex'

export default {
  name: 'SwitchCentro',
  props: {
    user: { type: Object, required: true }
  },
  data() {
    return {
      centers: [],
      selected: null,
      loading: false
    };
  },
  created() {
    this.loadCenters();
  },
  methods: {
    ...mapMutations('user', ['switchCenterId']),
    ...mapActions({
      getList: 'centers/getList'
    }),

    async loadCenters() {
      this.loading = true;
      try {

        const data = await this.getList();

        const centersMap = {};
        data.forEach(center => {
          centersMap[center._id] = {
            _id: center._id,
            desc: center.name || center.desc || 'Centro senza nome'
          };
        });

        const ids = JSON.parse(localStorage.getItem('available_centers') || '[]');

        const uniqueIds = [...new Set(ids)];
        this.centers = uniqueIds
            .map(id => centersMap[id])
            .filter(Boolean);

        this.selected = centersMap[this.user.center_id] || null;
      } catch (err) {
        console.error('[SwitchCentro] Errore:', err);
      } finally {
        this.loading = false;
      }
    },

    async handleSwitch(center) {
      if (!center || !center._id) return;
      this.switchCenterId(center._id);
      window.location.href = '/'
    }
  }
};
</script>
